<template>
	<v-container fluid fill-height style="padding: 0">
		<v-layout>
			<v-flex>
				<v-card tile elevation="0">
					<div style="padding: 0.5rem">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									icon
									:color="`${isDark ? 'grey lighten-3' : 'grey darken-3'}`"
									@click="handleRefresh"
								>
									<v-icon>refresh</v-icon>
								</v-btn>
							</template>
							{{ $t('tooltip.refresh') }}
						</v-tooltip>
					</div>
					<v-divider></v-divider>
					<div>
						<v-tabs v-model="tab" slider-size="3" slider-color="primary">
							<v-tab v-if="userRole >= 666">
								{{ $t('tab.forms') }}
							</v-tab>
						</v-tabs>
					</div>
					<v-divider></v-divider>
					<v-tabs-items v-model="tab">
						<v-tab-item v-if="userRole >= 666">
							<FormRulesets></FormRulesets>
						</v-tab-item>
					</v-tabs-items>
				</v-card>
				<router-view></router-view>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapState } from 'vuex';
import FormRulesets from './formRulesets/FormRulesets';

export default {
	name: 'Rulesets',
	components: {
		FormRulesets,
	},
	computed: {
		...mapState({
			isDark: state => state.currentUser.isDark,
			userRole: state => state.currentUser.userRole,
		}),
	},
	data() {
		return {
			tab: 0,
		};
	},
	created() {
		this.$store.dispatch('company/get', {
			refresh: true,
			updateStore: true,
		});
	},
	methods: {
		handleRefresh() {
			this.$store.dispatch('company/get', {
				refresh: true,
				updateStore: true,
			});
		},
	},
};
</script>
